import React from 'react';
import { Outlet } from 'react-router-dom';
import { LanguageDetector } from '../LanguageDetector';

export const Layout: React.FC = () => {
  return (
    <>
      <LanguageDetector />
      <Outlet />
    </>
  );
};